export { MixpanelAnalyticsApi, getLastInAppPath } from './MixpanelAnalyticsApi';
export { getPageSection } from './pageSection';
export type { PageSection } from './pageSection';
export { getPageTitle } from './pageTitle';
export { hashEmail } from './hashIdentity';

import mixpanel from 'mixpanel-browser';

export function useMixpanelAnalytics() {
  function track(
    eventName: string,
    properties?: Record<string, any>,
  ): void {
    try {
      mixpanel.track(eventName, properties);
    } catch (_e) {
      // never crash the portal
    }
  }
  return { track };
}
